module.exports = __webpack_public_path__ + "static/media/unlimitedGamesPlayed_250000_500000.af50af81.png";